// Contacto fijado arriba de la lista (Victor 2026-05-22): el número personal
// de Victor queda pinneado de PRIMERO en la lista de conversaciones de las
// sucursales La Romana (LRM), Santiago (STG), SDO y SDE. Visible para todos los
// agentes e independiente del orden (más reciente / más antigua) y del filtro
// de canal. La tarjeta se renderiza con nombre fijo + advertencia de privacidad.
export const PINNED_PHONE_DIGITS = '8495280461';
export const PINNED_DISPLAY_NAME = 'Victor Guzman Personal';
export const PINNED_WARNING = 'Prohibido compartir el número sin autorización';
const PINNED_BRANCH_CODES = ['lrm', 'sde', 'sdo', 'stg'];

// Compara por los últimos 10 dígitos para tolerar prefijos (+1, 1, espacios…).
export function isPinnedPhone(phone) {
  const digits = (phone || '').replace(/\D/g, '');
  return digits.length >= 10 && digits.endsWith(PINNED_PHONE_DIGITS);
}

export function isPinnedBranchCode(code) {
  return PINNED_BRANCH_CODES.includes((code || '').toLowerCase());
}
